import {BigWinView} from '@gongxigames/framework/slot/modules/bigwin/BigWinViewParticlesV5';
import {BigWinModule} from '@gongxigames/framework/slot/modules/bigwin/BigWinModule';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow';
import {ModuleState} from '@gongxigames/framework/slot';

export class BigWinBasicState extends ModuleState<BigWinView, BigWinModule> {

    public onEnterState(): void {
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
        this.setEventHandler(FlowModuleEvents.WON_BIG_WIN, this.onBigWinWon.bind(this));
    }

    protected onBigWinWon(): void {
        if (!this.isAutoplaySkip()) {
            this.module.gotoState(BigWinModule.PLAYING_STATE);
        }
    }

    protected isAutoplaySkip(): boolean {
        return this.module.settings.get('autoplayMode') && this.module.settings.get('autoplaySkipBigWins');
    }
}
